export class LoginPayload {
  username: string;
  password: string;
  timestamp: number;
  clientId: number;
  companyId: number;
}


// WEBPACK FOOTER //
// ./src/app/services/user/payload/login.payload.ts